{
  "monacoEditor": {
    "noHistoryData": "There are no records in the history",
    "currentValue": "Current value",
    "addToCompare": "Add to the list for comparison",
    "reloadConfig": "Reload configuration",
    "goToCompare": "Switch to comparison mode"
  },
  "compareDialog": {
    "title": "Attribute value comparison",
    "base": "Base",
    "compared": "Compared",
    "cit": "CIT",
    "ci": "CI",
    "attribute": "Attribute",
    "changedAt": "Changed at",
    "search": "Search",
    "searchPlaceholder": "Search...",
    "sideView": "Side",
    "inlineView": "Inline",
    "onlyChanges": "Only changes",
    "unchangedLines": "$ unchanged lines",
    "changes": "Differences",
    "changedLines": "Changed lines",
    "diffMetadata": "Diff metadata",
    "ciId": "CI id",
    "validUntil": "Valid until",
    "exportDiff": "Export diff"
  },
  "assignUser": {
    "assignAt": "Assign at",
    "assign": "Assigned",
    "none": "Not assigned"
  }
}